<template>
  <v-container class="form-top">
    <v-layout align-center justify-center>
      <v-flex>
        <v-form>
          <v-card>
            <v-toolbar color="blue">
              <v-toolbar-title>Login form</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-text-field v-model="Username" prepend-icon="mdi-account-box" name="login" label="Login"
                            type="text"></v-text-field>
              <v-text-field v-model="Password" prepend-icon="mdi-lock" name="password" label="Password"
                            type="password"></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="login({Username,Password})">
                Login
                <v-icon>mdi-arrow-right-bold</v-icon>
              </v-btn>
            </v-card-actions>

          </v-card>
        </v-form>
      </v-flex>
    </v-layout>

  </v-container>

</template>
<script>
import {authService} from '@/services/AuthService'

export default {
  computed: {},
  data: () => ({
    Username: '',
    Password: '',
    Email: '',
  }),
  methods: {
    async login(user) {
      const usr = await authService.login(user)

      if (usr.JwtToken) {
        window.location.replace('/order-today')
      }
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: #f7f7f7;
}

.form-top {
  max-width: 500px;
  margin-top: 15% !important;
}

.v-input__icon--double .v-input__icon {
  margin-left: -4.25rem !important;
}

input {
  width: 50px !important;
}

a.no-text-decoration {
  text-decoration: none;
}

#signinup-form {
  max-width: 75rem;
}

.signup-form-form {
  max-width: 23rem;
  margin: 0 auto;
}

.card {
  overflow: hidden;
}

.vcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>